const UNIDADE = {
    D: { id: 'D', base: 100, descricao: 'Dia' }, //1
    M: { id: 'M', base: 3000, descricao: 'Mês' }, //2
    A252: { id: 'A252', base: 25200, descricao: 'Ano com 252 dias' }, //6 ANO_252
    A360: { id: 'A360', base: 36000, descricao: 'Ano com 360 dias' }, //3 ANO_360
    A365: { id: 'A365', base: 36500, descricao: 'Ano com 365 dias' }, //4 ANO_365
    AM: { id: 'AM', base: 1200, descricao: 'Ano convertido ao mês' }, //5 ANO12 ANO_12_MES_VARIAVEL
    AMC: { id: 'AMC', base: 1200, descricao: 'Ano convertido ao mês e depois para dias do mês' }, //9  //ANO12DIASDOMES (9) //12 Meses/Dias do Mês
    AD: { id: 'AD', base: 100, descricao: 'Ano convertido para dias do ano' }, //8 //ANODIASDOANO
    AP: { id: 'AP', base: 36000, descricao: 'Ano convertido para período' }, //10 ANOPERIODO360
    P: { id: 'P', base: 100, descricao: 'No período' } //7 PERIODO
};

module.exports = UNIDADE;

// Enum DBCnsUnidade
//     Dia = 1
//     Mes = 2
//     Ano360 = 3
//     Ano365 = 4
//     Ano12 = 5
//     Ano252 = 6
//     Periodo = 7
//     AnoDiasDoAno = 8
//     Ano12DiasdoMes = 9
//     AnoPeriodo360 = 10
// End Enum

// Enum DBCnsEmprestimoDevolucaoTipo
//     DevolucaoVencimento = 0
//     DevolucaoAQualquerMomentoPeloTomador = 1
//     DevolucaoAQualquerMomentoPorAmbos = 2
// End Enum

// Enum DBCnsIndiceSelecao
//     Maior
//     Menor
//     Todos
// End Enum

// Enum DBCnsVigencia
//     Diaria = 1
//     Mensal = 2
//     Anual = 3
//     Irregular = 4
//     Emissao = 5
//     Vencimento = 6
// End Enum

// Enum DBCnsCotacao
//     Abertura = 1
//     Media = 2
//     Fechamento = 3
//     Ajustado = 4
// End Enum

// Enum DBCnsCapitalizacao
//     PuEmissao = 1         'Captaliza a partir da data de emiss„o
//     PuVencimento = 2      'Descaptaliza a partir da data de vencimento
//     PuOperado = 3         'Captaliza a partir da data da operaÁ„o
//     PuIntegralizacao = 4  'Captaliza a partir da data de IntegralizaÁ„o
// End Enum

// Enum DBCnsCurvaTipo
//     Pre = 1
//     Pos = 2
//     PrePos = 3
// End Enum

// Enum DBCnsProdutoAcaoTipo
//     NaoTipificado = -1
//     Ordinaria = 0
//     Preferencial = 1
//     Unit = 2
// End Enum

// Enum DBCnsCotacaoModo
//     Automatica = 0       'Diretamente do Arquivo de integraÁ„o
//     Calculada = 1        'Calculada pelos sistema quando da existencia de determinados eventos e sem cotaÁ„o autom·tica na data
//     Manual = 2           'Digitada pelo Usu·rio
//     SeisMeses = 3        'Digitada pelo Usu·rio, apÛs seis meses sem cotaÁ„o baseado no Patrimonio Liquido da Empresa
//     SeisMesesCusto = 4   'Digitada pelo Usu·rio, apÛs seis meses sem cotaÁ„o baseado no Custo do papel
//     ValorEconomico = 5   'Digitada pelo Usu·rio baseado no valor economico da empresa
// End Enum
